import { render } from "./BinanceChart.vue?vue&type=template&id=6e2d922a&ts=true"
import script from "./BinanceChart.vue?vue&type=script&lang=ts"
export * from "./BinanceChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__